import { Link } from "react-router-dom";
import { ArrowUpRight, Wind, Hand, Gem, Users } from "lucide-react";
import { Reveal } from "../components/Reveal";

const ATELIERS = [
  {
    icon: Wind,
    title: "Breathwork",
    text: "Une respiration consciente et soutenue, guidée en musique, pour libérer les émotions, apaiser le mental et retrouver une détente profonde.",
  },
  {
    icon: Gem,
    title: "Kintsugi Breathwork — Vibre ta voix",
    text: "L'art japonais de l'or appliqué à nos blessures : raconter son histoire, déposer de l'or là où ça a été cassé, puis voyager par le souffle et libérer sa voix.",
  },
  {
    icon: Hand,
    title: "Massage des mains — Shinzu",
    text: "Apprendre l'auto-massage des mains et la puissance des mudras : détox, sommeil retrouvé, énergie — un monde entier au bout de tes doigts.",
  },
];

export default function Ateliers() {
  return (
    <div data-testid="ateliers-page">
      <section className="pt-32 lg:pt-40 pb-16 px-6 lg:px-12 max-w-7xl mx-auto">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-olive mb-6">En groupe · Bayonne & Bellignat</p>
          <h1 className="font-serif text-5xl sm:text-6xl font-light tracking-tight text-ink leading-tight max-w-3xl">
            Les ateliers
          </h1>
          <p className="mt-8 text-base sm:text-lg text-sage leading-relaxed max-w-2xl">
            Respiration, voix et toucher : des temps en petit groupe pour déposer, libérer et repartir plus légère. Nul besoin d'expérience — viens comme tu es.
          </p>
        </Reveal>
      </section>

      <section className="pb-20 px-6 lg:px-12 max-w-7xl mx-auto">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="ateliers-list">
          {ATELIERS.map((a, i) => (
            <Reveal key={a.title} delay={i * 0.1}>
              <div className="h-full bg-beige-50 border border-olive-border rounded-3xl p-8 transition-transform duration-500 hover:-translate-y-1" data-testid={`atelier-${i}`}>
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-olive-soft border border-olive-border">
                  <a.icon className="w-5 h-5 text-olive" strokeWidth={1.5} />
                </span>
                <h2 className="mt-6 font-serif text-2xl sm:text-3xl text-ink">{a.title}</h2>
                <p className="mt-4 text-sm sm:text-base text-sage leading-relaxed">{a.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <Link
            to="/constellations"
            data-testid="ateliers-link-constellations"
            className="group mt-10 flex flex-wrap items-center justify-between gap-6 bg-olive-dark text-beige-100 rounded-3xl p-8 sm:p-10 transition-transform duration-500 hover:-translate-y-1"
          >
            <div className="flex items-start gap-5 max-w-2xl">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-beige-100/10 border border-beige-100/25">
                <Users className="w-5 h-5" strokeWidth={1.5} />
              </span>
              <div>
                <p className="text-xs uppercase tracking-[0.25em] text-beige-300/80 mb-2">L'atelier fondateur</p>
                <h2 className="font-serif text-2xl sm:text-3xl font-light">Les constellations ont leur page dédiée</h2>
                <p className="mt-3 text-sm text-beige-300/85 leading-relaxed">Familiales, systémiques, karmiques ou individuelles : découvre comment le groupe révèle ce qui se joue et libère les nœuds.</p>
              </div>
            </div>
            <ArrowUpRight className="w-6 h-6 shrink-0 text-beige-300 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" strokeWidth={1.5} />
          </Link>
        </Reveal>
      </section>

      <section className="bg-beige-200/50 border-t border-olive-border/60">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20 flex flex-wrap items-center justify-between gap-8">
          <Reveal>
            <h2 className="font-serif text-3xl sm:text-4xl font-light text-ink leading-snug max-w-xl">Petit groupe, journée ou demi-journée — dates et tarifs sur demande.</h2>
          </Reveal>
          <Reveal delay={0.15}>
            <Link to="/contact?soin=ateliers" data-testid="ateliers-cta-bottom" className="inline-flex items-center gap-2 rounded-full bg-olive px-8 py-4 text-sm font-medium text-beige-100 transition-all duration-300 hover:bg-olive-dark hover:-translate-y-0.5">
              Participer à un atelier <ArrowUpRight className="w-4 h-4" strokeWidth={1.5} />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
